import {onPremisseses} from '../../../../_metronic/helpers'
import {AuthModel} from './_models'

type OnPremisesAccess = Pick<AuthModel, 'isOnPremises'>

// The backend capability is authoritative. The environment flag keeps older
// backend/frontend deployments compatible during a rolling deployment.
export const isOnPremisesInstallation = (user?: OnPremisesAccess | null): boolean =>
  user?.isOnPremises ?? Boolean(onPremisseses)
